import { css } from '@emotion/react'

const controlsHeight = '40px'
const playerZIndex = 20

export const playerStyle = css`
  .video-js {
    position: absolute;
    width: 100%;
    height: 100%;
    z-index: 20;
    top: 0;
  }
  .video-js .vjs-control-bar {
    height: 120px;
    align-items: flex-end;
    background: linear-gradient(
      0deg,
      rgba(8, 8, 10, 0.24) 100px,
      rgba(8, 8, 10, 0)
    );
    z-index: ${playerZIndex + 1};
  }
  .video-js .vjs-control {
    height: ${controlsHeight};
  }
  .video-js .vjs-control:focus {
    text-shadow: none;
  }
  .video-js .vjs-progress-control {
    position: absolute;
    bottom: ${controlsHeight};
    right: 10px;
    left: 10px;
    width: calc(100% - 20px);
    height: 8px;
  }
  .video-js .vjs-progress-holder {
    height: 8px;
    border-radius: 4;
  }
  .video-js .vjs-load-progress div {
    border-radius: 4;
  }
  .video-js .vjs-button > .vjs-icon-placeholder::before {
    line-height: ${controlsHeight};
  }
  .video-js .vjs-big-play-button {
    background: transparent;
    background-color: none;
    border: none;
  }
  .video-js:hover .vjs-big-play-button {
    background: transparent;
  }
  .video-js .vjs-big-play-button .vjs-icon-placeholder {
    position: absolute;
    top: 50%;
    left: 50%;
    display: block;
    content: '';
    box-sizing: border-box;
    border-color: transparent transparent transparent #fff;
    border-style: solid;
    border-width: 26px 0 26px 40px;
    transform: translate(-50%, -50%);
  }
  .video-js .vjs-big-play-button .vjs-icon-placeholder::before {
    content: none;
  }
  .video-js .vjs-big-play-button .vjs-icon-placeholder::after {
    content: none;
  }
  .video-js .vjs-play-progress {
    border-radius: 4;
    background-color: rgba(255, 255, 255, 0.5);
  }
  .video-js .vjs-play-progress::before {
    content: '';
    cursor: grab;
    background-color: rgba(255, 255, 255, 1);
    top: -2px;
    right: -2px;
    width: 12px;
    height: 12px;
    border-radius: 50%;
    z-index: 2;
  }
  .video-js .vjs-menu .vjs-menu-content {
    z-index: 2;
  }
  .video-js .vjs-play-control {
    order: 0;
  }
  .video-js .vjs-seek-to-live-control {
    order: 10;
  }
  .video-js .vjs-seek-to-live-control .vjs-icon-placeholder,
  .video-js .vjs-seek-to-live-text,
  .video-js .vjs-remaining-time-display {
    line-height: ${controlsHeight};
  }
  .video-js .vjs-spacer {
    order: 30;
    flex-grow: 1;
  }
  .video-js .vjs-volume-panel {
    order: 40;
  }
  .video-js .vjs-volume-panel .vjs-volume-bar {
    margin: 1.85em 0.45em;
  }
  .video-js .vjs-quality-selector {
    order: 50;
  }
  .video-js .vjs-picture-in-picture-control {
    order: 60;
  }
  .video-js .vjs-chromecast-button {
    order: 70;
  }
  .video-js .vjs-chromecast-button .vjs-icon-placeholder {
    height: 18px;
    width: 18px;
  }
  .video-js .vjs-fullscreen-control {
    order: 80;
    display: block;
  }
  .video-js .vjs-subs-caps-button {
    display: none;
  }
  .video-js .vjs-liveui .vjs-play-progress {
    background-color: 'rgba(255, 85, 106, 1)';
  }
  .video-js .vjs-ad-playing {
    z-index: ${playerZIndex + 1};
  }
`
